module.exports = __webpack_public_path__ + "img/1363150272.24149be4.jpg";